import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import { LeadsListContainer } from './containers/leads-list/leads-list.container';
import { LeadDetailsContainer } from './containers/lead-details/lead-details.container';

const CHILDREN = APP_ROUTES.LEAD_MODULE.CHILDREN as RouteConfig;

export const LeadModule: React.FC = () => {
  return (
    <>
      <Route exact path={APP_ROUTES.LEAD_MODULE.FULL_PATH}>
        <Redirect to={CHILDREN.LIST.FULL_PATH} />
      </Route>
      {/* Details is declared before List so `/leads/details/:leadId` is not
          swallowed by the list route. */}
      <Route path={CHILDREN.DETAILS.FULL_PATH} component={LeadDetailsContainer} />
      <Route exact path={CHILDREN.LIST.FULL_PATH} component={LeadsListContainer} />
    </>
  );
};
